import clsx from 'clsx';
import {Image} from '@shopify/hydrogen';
import type {Collection as ShopifyCollection} from '@shopify/hydrogen/storefront-api-types';

export function CollectionHeader({
  collection,
  parentTitle,
  className,
}: {
  collection: ShopifyCollection;
  parentTitle?: string;
  className?: string;
}) {
  const styles = clsx('bg-bgDark text-white', className);

  const descMaxLength = 330;
  const descIsTooLong = collection.description.length > 330;
  const truncate = (str: string, n: number, useWordBoundary: boolean) => {
    if (str.length <= n) {
      return str;
    }
    const subString = str.slice(0, n - 1); // the original check
    return (
      (useWordBoundary
        ? subString.slice(0, subString.lastIndexOf(' '))
        : subString) + '...'
    );
  };

  return (
    <header className={styles}>
      <div className="container grid grid-cols-1 lg:grid-cols-5">
        <div className="lg:col-span-3 lg:pr-8 py-8 flex flex-col justify-end">
          {parentTitle && (
            <>
              <span className="text-4xl text-outline-white text-transparent font-clash uppercase break-words md:text-5xl">
                {parentTitle}
              </span>
              <h1 className="pb-0 mb-0 break-words">{collection.title}</h1>
            </>
          )}
          {!parentTitle && (
            <h1 className="text-4xl pb-0 mb-0 font-clash uppercase md:text-5xl break-words">
              {collection.title}
            </h1>
          )}
          {descIsTooLong ? (
            <div className="pt-4">
              {truncate(collection.description, descMaxLength, true)}
              <br />
              <a className="underline" href="#fullDesc">
                Lue lisää
              </a>
            </div>
          ) : (
            <div className="pt-4">{collection.description}</div>
          )}
        </div>
        <div className="hidden lg:block lg:col-span-2 py-8">
          {collection.image && (
            <Image
              data={{
                ...collection?.image,
                altText: collection?.image.altText || 'Collection image',
              }}
            />
          )}
        </div>
      </div>
    </header>
  );
}
